const Data = [
    {
    'tipo': 'Bebidas',
    'formato': ['Cafés Calientes','Cafés Helados','Frappiccino®','Bebidas Calientes','Té Caliente','Té Helado','Bebidas Heladas']
},{
    'tipo': 'Comidas',
    'formato': ['Bakery','Sándwichs & preparados','Snacks']
},{
    'tipo': 'En Casa',
    'formato': ['Café en granos','Té','Merchandising']
}
]

export default Data 